import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import "../../../components/common/bt.css";

const AdvanceCustomerBalanceTable = ({ printMode = false }) => {
  const { list, loading } = useSelector((state) => state.advanceCustomerBalance);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Customer Name", dataIndex: "customerName" },
    { title: "Contact No", dataIndex: "contactNo" },
    { title: "Address", dataIndex: "address" },
    {
      title: "Received",
      dataIndex: "received",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Payment",
      dataIndex: "payment",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
  ];

  const totals = list.reduce(
    (acc, row) => {
      acc.received += Number(row.received || 0);
      acc.payment += Number(row.payment || 0);
      acc.balance += Number(row.balance || 0);
      return acc;
    },
    { received: 0, payment: 0, balance: 0 }
  );

  if (printMode) {
    return (
      <table className="ledger-print-table">
        <colgroup>
          <col style={{ width: "4%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "14%" }} />
          <col style={{ width: "27%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "9%" }} />
          <col style={{ width: "9%" }} />
        </colgroup>
        <tbody>
          <tr className="ledger-print-heading">
            <td>No.</td>
            <td>Customer Name</td>
            <td>Contact No</td>
            <td>Address</td>
            <td style={{ textAlign: "right" }}>Received</td>
            <td style={{ textAlign: "right" }}>Payment</td>
            <td style={{ textAlign: "right" }}>Balance</td>
          </tr>

          {list.map((row, index) => (
            <tr key={row.id || index}>
              <td>{index + 1}</td>
              <td>{row.customerName}</td>
              <td>{row.contactNo}</td>
              <td  style={{
    maxWidth: "80px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  }}
              >{row.address}</td>
              <td style={{ textAlign: "right" }}>{Number(row.received || 0).toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>{Number(row.payment || 0).toFixed(2)}</td>
              <td style={{ textAlign: "right" }}>{Number(row.balance || 0).toFixed(2)}</td>
            </tr>
          ))}

          <tr className="ledger-total-row">
            <td colSpan={4} style={{ textAlign: "right" }}>Grand Total</td>
            <td style={{ textAlign: "right" }}>{totals.received.toFixed(2)}</td>
            <td style={{ textAlign: "right" }}>{totals.payment.toFixed(2)}</td>
            <td style={{ textAlign: "right" }}>{totals.balance.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={4}>
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={4} align="right">
            {totals.received.toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5} align="right">
            {totals.payment.toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6} align="right">
            {totals.balance.toFixed(2)}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default AdvanceCustomerBalanceTable;
